import React from 'react';
import Layout from '../../layout';






function Divisions() {
  return (
   <Layout>
         <section class="page-header padding">
           <div class="overlay"></div>
            <div class="container">
               <div class="section-heading mt-40 text-center">
                    <h4 class="sub-heading">Vision And Mission</h4>
                    <h2>High Quality Construction Solutions <br/>For Residentials &amp; Industries!</h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
            </div>
        </section>

        <section class="content-section-2 bd-bottom padding">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6">
                        <div class="section-heading">
                            <h2>Derm Elevators <span>Limited</span></h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <a href="#" class="default-btn">VISIT WEBSITE <span></span></a>
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding">
                        <div class="content-thumb">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700586358/derma/z0d5svol36yizluwpfd8.png" alt="post"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <section class="content-section-2 padding" style={{backgroundColor: '#eeeeee'}}>
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6 sm-padding">
                        <div class="content-thumb">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700586359/derma/bc1jmimnoi7t36qtta7l.png" alt="post"/>
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding">
                        <div class="section-heading ml-20">
                            <h2>Coast Concretes Poles <span>Limited</span></h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <a href="#" class="default-btn">VISIT WEBSITE <span></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="content-section-2 bd-bottom padding">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6">
                        <div class="section-heading">
                            <h2>Skyline Properties <span>Limited</span></h2>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <p>Construction is a general term meaning the art and science to form objects systems organizations, and comes from Latin construction and Old French construction. To construct is the verb: the act of building, and the noun is construction.</p>
                            <a href="#" class="default-btn">VISIT WEBSITE<span></span></a>
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding">
                        <div class="content-thumb">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700586359/derma/necxzjic0dqgzhxbg16y.png" alt="post"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cta-section padding">
           <div class="overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 offset-lg-3">
                        <div class="cta-content text-center">
                            <div class="section-heading text-center">
                                <h4 class="sub-heading">Contact Us</h4>
                                <h2>Trusted By More Than 650,000 <br/>Happy<span> Peoples!</span></h2>
                                <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                            </div>
                            <a href="#" class="default-btn">Get a free quote <span></span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="sponsor-section">
            <div class="container">
                <div class="slider sponsor-carousel nav-style">
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-6.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-5.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-3.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                    <div class="sponsor-item">
                        <img src="https://themes.dynamiclayers.net/industrus/wp-content/uploads/sites/17/2020/11/sponsor-4.png" alt="sponsor"/>
                    </div>
                </div>
            </div>
        </div> 
   </Layout>
  );
}

export default Divisions;